import { render, staticRenderFns } from "./UpcomingCollectionSummary.vue?vue&type=template&id=90007692&scoped=true&"
import script from "./UpcomingCollectionSummary.vue?vue&type=script&lang=js&"
export * from "./UpcomingCollectionSummary.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingCollectionSummary.vue?vue&type=style&index=0&id=90007692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90007692",
  null
  
)

export default component.exports